import React, { useMemo, useState } from "react";
import { connect, useDispatch } from 'react-redux';
import ContentSections from "./ContentSections";
import i18n from 'I18n';
import { useFormContext } from "react-hook-form";
import { SectionTopTitle } from "./CommonComponent";
import Loading from "./Loading";

const mapPropsToState = (state) => ({
  languages: state.language.allList,
});

const BaseCreationStepContentByConfig = ({
  configuration,
  languages,
  isLoading = false,
  ...otherProps
}) => {
  const formContext = useFormContext();
  const {
    isConfigByKey = false,
    getSectionKey,
    getDisplayComponentKeys,
    languageSections: languageSectionConfig,
    normalSections: normalSectionConfig,
  } = configuration

  const {
    displayNormalSectionComponents,
    displayLanguageSectionComponents
  } = getDisplayComponentKeys({ formContext })
  const [normalSections, languageSections] = useMemo(() => {
    if (isConfigByKey) {
      const sectionKey = getSectionKey({ formContext })
      
      return [normalSectionConfig?.[sectionKey] || [], languageSectionConfig?.[sectionKey] || []]
    } else {
      return [normalSectionConfig, languageSectionConfig]
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [isConfigByKey])

  const [activeSection, setActiveSection] = useState();
  const dispatch = useDispatch();

  const getNormalSections = () => {
    if (isLoading) {
      return [<Loading />]
    }
    return normalSections.map((section) => {
      const sectionDisplayComponents = section?.sectionContent?.filter(
        (componentConfig) => displayNormalSectionComponents?.includes(componentConfig?.key)
      ) || []
      if (sectionDisplayComponents.length < 1) {
        return null
      }
      const displaySectionTitle = section?.sectionTitle ||
        (section?.getDisplaySectionTitle && section.getDisplaySectionTitle({ formContext }))
      const displaySectionDescription = section?.description ||
        (section?.getDisplaySectionDescription && section.getDisplaySectionDescription({ formContext }))
      return (
        <>
          {displaySectionTitle && <SectionTopTitle title={displaySectionTitle} />}
          {displaySectionDescription &&
            <label className={`section-short-description ${section?.descriptionClass || ""}`}>
              {displaySectionDescription}
            </label>
          }
          {sectionDisplayComponents.map((componentConfig) => {
            if (componentConfig?.complexComponent) {
              return componentConfig.complexComponent({
                setActiveSection,
                dispatch,
                formContext,
              })
            }
            return componentConfig?.component ?
              <componentConfig.component
                focusChange={setActiveSection}
                {...componentConfig?.componentProps}
              />
              : null
          })}
        </>
      )
    })
  }

  const getLanguageTabs = (language) => {
    if (isLoading) {
      return [<Loading />]
    }
    return languageSections?.map((sectionConfig) => {
      const sectionDisplayComponents = sectionConfig?.sectionContent?.filter(
        (componentConfig) => displayLanguageSectionComponents?.includes(componentConfig?.key)
      ) || []
      if (sectionDisplayComponents.length < 1) {
        return null
      }

      const displaySectionTitle = sectionConfig?.sectionTitle ||
        (sectionConfig?.getDisplaySectionTitle && sectionConfig.getDisplaySectionTitle({ formContext }))

      const displaySectionDescription = sectionConfig?.description ||
        (sectionConfig?.getDisplaySectionDescription && sectionConfig.getDisplaySectionDescription({ formContext }))
      return (
        <>
          {displaySectionTitle && <SectionTopTitle title={i18n.t(displaySectionTitle, { locale: language })} />}
          {displaySectionDescription &&
            <label className={`section-short-description ${sectionConfig?.descriptionClass || ""}`}>
              {i18n.t(displaySectionDescription, { locale: language })}
            </label>
          }
          {sectionDisplayComponents.map(fieldInput => {
            if (fieldInput?.complexComponent) {
              return fieldInput.complexComponent({
                languages,
                language,
                focusChange: setActiveSection ,
                setActiveSection,
                dispatch,
                formContext,
              })
            }
            return fieldInput?.component ?
              <fieldInput.component
                focusChange={setActiveSection}
                language={language}
                {...fieldInput?.componentProps}
              />
              : null
          })}
        </>)
    })
  };
  return <ContentSections
    sections={getNormalSections()}
    languageTabContent={displayLanguageSectionComponents?.length > 0 ? {
      containers: languages?.map((language) => {
        return {
          container: getLanguageTabs(language.code),
          key: language.code,
          title: language.sourceName,
        };
      }),
    } : null}
    activeSection={activeSection}
    {...otherProps}
  />
}

export default connect(mapPropsToState)(BaseCreationStepContentByConfig);

